import { useSelector } from 'react-redux';

import { isAffirmBnplAmountEligible } from 'shared/PaymentHelpers';
import {
  affirmMinTxnLimitRawSelector,
  affirmMaxTxnLimitRawSelector,
} from 'store/payment/selectors';
import { RootState } from 'store/store';

export function useAffirmBnplHasValidAmount(): boolean {
  const amount = useSelector((state: RootState) => state.payment?.amount);
  const affirmMinTxnLimit = useSelector(affirmMinTxnLimitRawSelector);
  const affirmMaxTxnLimit = useSelector(affirmMaxTxnLimitRawSelector);

  return isAffirmBnplAmountEligible(amount, affirmMinTxnLimit, affirmMaxTxnLimit);
}
